import { createFileRoute } from "@tanstack/react-router";
import { DashboardSkeleton } from "@/pages/dashboard/DashboardSkeleton";
import { SellerProductsPage } from "@/pages/dashboard/products/SellerProductsPage";

// Real seller products (docs/plans/marketplace-commerce.md M4). The dashboard layout already requires a store.
export const Route = createFileRoute("/dashboard/products")({
  pendingComponent: DashboardSkeleton,
  component: SellerProductsPage,
});
